import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import "./login.scss";

const Login = () => {
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const [err, setErr] = useState(null);

  const navigate = useNavigate()

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(inputs);
      navigate("/")
    } catch (err) {
      setErr(err.response.data);
    }
  };

  return (
    <div className="login">
      <div className="card">
        <div className="left">
          <h1>VOLUNTEER APP</h1>
          <p style={{marginBottom:'0px'}}>
          «Волонтер» з французької означає «доброволець», тобто «волонтерство» – суспільно важлива, безкорислива, добровільна діяльність. 
          Принципом такої діяльності є те, що особистість діє за покликом душі, через потребу реалізувати свою громадську позицію. 
          Саме це сприяє формуванню суспільної свідомості.
          </p>
          <span style={{marginTop:'0px'}}>Ви не маєте облікового запису?</span>
          <Link to="/register">
            <button>Зареєструватись</button>
          </Link>
          
        </div>
        <div className="right">
          <h1>Вхід в обліковий запис</h1>
          <form>
            <input
              type="text"
              placeholder="Пошта"
              name="email"
              onChange={handleChange}
            />
            <input
              type="password"
              placeholder="Пароль"
              name="password"
              onChange={handleChange}
            />
            {err && err}
            <button onClick={handleLogin}>Увійти</button><Link to='/' style={{textAlign:'center',textDecoration:'none',color:"black"}}>НА ГОЛОВНУ</Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;